import { render } from "./AlbumView.vue?vue&type=template&id=7acc35a6&scoped=true"
import script from "./AlbumView.vue?vue&type=script&lang=js"
export * from "./AlbumView.vue?vue&type=script&lang=js"

import "./AlbumView.vue?vue&type=style&index=0&id=7acc35a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acc35a6"]])

export default __exports__